import { Route, Routes } from "react-router-dom";
import { EmployeeEdit } from "./EmployeeEdit/EmployeeEdit";
import { EmployeeDetails } from "./EmployeeDetails/EmployeeDetails";
import { UserRoles } from "../../constants/userRoles";
import { PrivateRoute } from "../../keycloak";

export const EmployeeView = () => {
  return (
    <Routes>
      <Route path="details">
        <Route
          element={
            <PrivateRoute
              roles={{
                dcs_client: [UserRoles.USER_UPDATE],
              }}
            />
          }
        >
          <Route path="edit" element={<EmployeeEdit />} />
        </Route>

        <Route path="" element={<EmployeeDetails />} />
      </Route>
    </Routes>
  );
};
